// AddCourse.jsx
import React, { useEffect } from 'react';
import { Button } from 'app/components/ui/button';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useCourseSlice } from '../slice';
import { useForm } from 'react-hook-form';
import { toast } from 'sonner';
import { Form } from 'app/components/ui/form';
import CourseForm from '../Form';

export default function AddCourse() {
  const form = useForm({
    defaultValues: {
      status: 2,
    },
  });

  const { useAddCourseMutation } = useCourseSlice();
  const [addCourse, { isError, isLoading, data }] = useAddCourseMutation();

  const navigate = useNavigate();

  const onSubmit = async values => {
    try {
      await addCourse(values).unwrap();
    } catch (error) {
      toast.error(error.message || 'An error occurred');
    }
  };

  useEffect(() => {
    if (data) {
      toast.success(data?.message || 'Course added successfully');
      navigate('/courses');
    }
  }, [data, navigate]);

  return (
    <div className="bg-gray-100 min-h-screen p-4">
      <Form {...form}>
        <form onSubmit={form.handleSubmit(onSubmit)}>
          <div className="flex justify-between items-center mb-4">
            <h3 className="text-xl font-semibold">Add Course</h3>
            <Button type="submit" disabled={isLoading}>
              {isLoading ? 'Adding...' : 'Add Course'}
            </Button>
          </div>
          <CourseForm />
        </form>
      </Form>
    </div>
  );
}
